export default "__VITE_ASSET__C4KyAI5Z__"